export default __webpack_public_path__ + "static/media/exit.9b0a8c74.svg";